module.exports = __webpack_public_path__ + "static/media/james.21e437b3.jpg";